import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenHandling } from '../baseQuery';
import { getSearchQueryParamsForAPI } from 'src/utils/url.helpers';

const PROSPECTS_META_TAG = 'ProspectsMeta';

// Types
interface DataSourceInfo {
  [key: string]: any;
}

/**
 * RTK Query API for prospects metadata endpoints
 */
export const prospectsMetaApi = createApi({
  reducerPath: 'prospectsMetaApi',
  baseQuery: baseQueryWithTokenHandling,
  tagTypes: [PROSPECTS_META_TAG],
  endpoints: (builder) => ({
    /**
     * Query: Get data sources information
     */
    getDataSourcesInfo: builder.query<DataSourceInfo, void>({
      query: () => {
        const queryParams = getSearchQueryParamsForAPI({});
        return {
          url: `/v1/meta/data-sources${queryParams}`,
          method: 'GET',
        };
      },
      providesTags: [{ type: PROSPECTS_META_TAG, id: 'DATA_SOURCES' }],
    }),
  }),
});

export const {
  useGetDataSourcesInfoQuery,
} = prospectsMetaApi;
